import { render, staticRenderFns } from "./appsInfo.vue?vue&type=template&id=6d9f5f2c&"
import script from "./appsInfo.vue?vue&type=script&lang=js&"
export * from "./appsInfo.vue?vue&type=script&lang=js&"
import style0 from "./appsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports